import { render } from "./AppHeader.vue?vue&type=template&id=54a9e707&scoped=true"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=54a9e707&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54a9e707"

export default script